import styled from "styled-components";

const StyledContainer = styled.section`
    width: 100%;
    padding: 40px 10px;
    background: linear-gradient(135deg, #d1e8ff, #e8f3ff);
    box-sizing: border-box;
`;

const StyledBlock = styled.div`
    max-width: 700px;
    margin: 30px auto;
    padding: 30px 20px;
    background-color: #f0f0f0;
    border-radius: 10px;
    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.2);
`;

const StyledHeading = styled.h1`
    text-align: center;
    font-size: 32px;
    margin-bottom: 15px;
    color: #007bff;
    font-weight: bold;
`;

const StyledText = styled.div`
    font-size: 16px;
    line-height: 1.5;
    color: #2e3a4f;

    p {
        margin-bottom: 15px;
    }

    a {
        color: #007bff;
        text-decoration: none;
        font-weight: 500;
    }

    a:hover {
        text-decoration: underline;
    }
`;

const CookiePolicy = () => {
  return (
    <StyledContainer>
      <StyledBlock>
        <StyledHeading>France Investment - Politique de Confidentialité des Données</StyledHeading>
        <StyledText>
          <p>
            Chez France Investment, nous valorisons votre vie privée et nous engageons à protéger vos informations personnelles. Notre politique de confidentialité des données explique comment nous collectons, utilisons et sécurisons vos données lors de vos visites sur notre plateforme.
          </p>
          <p>
            Nous pouvons utiliser des cookies et des technologies similaires pour améliorer votre expérience d'apprentissage, évaluer le trafic de notre plateforme et personnaliser le contenu selon vos préférences. En continuant à utiliser notre plateforme, vous acceptez notre politique de confidentialité des données.
          </p>
          <p>
            Vous pouvez gérer ou supprimer les cookies via les paramètres de votre navigateur, bien que cela puisse affecter la fonctionnalité et la personnalisation de notre plateforme.
          </p>
          <p>
            Pour plus de détails, veuillez consulter notre{" "}
            <a href="/privacy" target="_blank" rel="noopener noreferrer">
              Politique de Confidentialité des Données
            </a>.
          </p>
        </StyledText>
      </StyledBlock>
    </StyledContainer>
  );
};
export default CookiePolicy;